import { Column } from '@/presentation/components/table';
import { MdLink } from 'react-icons/md';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '../types/collections';

export const columnsLinks: Column<Link>[] = [
  { header: 'Título', accessor: 'title' },
  {
    header: 'Descripción',
    accessor: 'description',
    render: (value) => {
      if (value && typeof value === 'string') {
        return (
          <span className="text-sm truncate block max-w-[400px]">{value}</span>
        );
      }
      return <span className="text-sm">No hay descripción</span>;
    },
  },
  {
    header: 'Enlace ES',
    accessor: 'linkSpanish',
    render: (value) =>
      value ? (
        <RouterLink to={value.toString()} target="_blank" rel="noreferrer">
          <div className="flex justify-center items-center">
            <MdLink className="text-blue-500" size={20} />
          </div>
        </RouterLink>
      ) : (
        <div className="flex justify-center items-center">
          <MdLink className="text-gray-500" size={20} />
        </div>
      ),
  },
  {
    header: 'Enlace EN',
    accessor: 'linkEnglish',
    render: (value) =>
      value ? (
        <RouterLink to={value.toString()} target="_blank" rel="noreferrer">
          <div className="flex justify-center items-center">
            <MdLink className="text-green-500" size={20} />
          </div>
        </RouterLink>
      ) : (
        <div className="flex justify-center items-center">
          <MdLink className="text-gray-500" size={20} />
        </div>
      ),
  },
  {
    header: 'Creado el',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        return (
          <span className="text-sm">
            {new Date(value.seconds! * 1000).toLocaleDateString('es-CO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        );
      }
      return <span className="text-sm">Desconocido</span>;
    },
  },
  {
    header: 'Vistas',
    accessor: 'views',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Favoritos',
    accessor: 'favorites',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Comentarios',
    accessor: 'comments',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
];
